export default "__VITE_ASSET__082f7230__"